import { twJoin } from "tailwind-merge";

export const getStyles = ({ isDeemphasizedCompany }) => ({
	featuredCompanyHeader: {
		wrapper:
			"tw:py-3 tw:px-2 tw:flex tw:justify-center tw:bg-[#0756C0] tw:text-white tw:rounded-t-[12px]",
		contentWrapper:
			"tw:text-center tw:text-base tw:font-semibold tw:leading-6 tw:sm:text-lg",
	},
	serviceFlag: {
		wrapper: "tw:absolute tw:mt-0 tw:top-4 tw:flex tw:gap-0.5",
		flag: twJoin(
			"tw:flex tw:h-[28px] tw:w-[28px] tw:items-center tw:justify-center",
			isDeemphasizedCompany ? "tw:bg-[#A6A5A6]" : "tw:bg-[#0756C0]",
		),
		number: "tw:text-white tw:text-sm tw:font-medium tw:leading-6",
		text: twJoin(
			isDeemphasizedCompany ? "tw:bg-[#A6A5A6]" : "tw:bg-[#212121]",
			"tw:flex tw:items-center tw:pt-0.5 tw:pr-4 tw:pl-2 tw:text-sm tw:leading-6 tw:font-medium tw:text-white tw:[clip-path:polygon(100%_0,calc(100%-10px)_100%,0_100%,0_0)]",
		),
	},
	companyLogo: {
		picture: "",
		image: isDeemphasizedCompany ? "tw:opacity-50" : "",
	},
	rating: {
		wrapper:
			"tw:w-fit tw:inline-flex tw:items-center tw:rounded-full tw:bg-white tw:shadow-[0px_4px_24px_0px_rgba(23,23,23,0.08),0px_0px_1px_0px_rgba(23,23,23,0.16)] tw:py-2 tw:gap-2 tw:pr-4 tw:pl-3.5",
		score: twJoin(
			isDeemphasizedCompany && "tw:hidden",
			"tw:text-[28px] tw:leading-9 tw:font-semibold tw:tracking-[-1.12px] tw:text-[#212121]",
		),
		stars: "tw:flex tw:flex-col tw:gap-1",
		starColor: "tw:text-[#1770d5]",
		starSize: twJoin(isDeemphasizedCompany && "tw:hidden", "tw:text-base"),
		count: isDeemphasizedCompany
			? "tw:text-sm tw:font-medium tw:leading-4 tw:text-[#949597] tw:pt-0.5"
			: "tw:ml-px tw:text-xs tw:font-semibold tw:leading-4 tw:text-[#212121]",
	},
	benefitsList: {
		wrapper: "tw:mt-4",
		list: "tw:flex tw:flex-col tw:gap-2 tw:justify-center",
		listItem: twJoin(
			"tw:flex tw:gap-2 tw:text-base tw:leading-6",
			isDeemphasizedCompany ? "tw:text-[#949597]" : "tw:text-[#212121]",
		),
	},
	socialProof: {
		wrapper:
			"tw:relative tw:w-full tw:flex tw:pt-2 tw:justify-center tw:border-t tw:border-[#F0F0F0] tw:lg:max-w-fit tw:lg:bg-white tw:lg:rounded-lg tw:lg:p-2 tw:lg:filter-[drop-shadow(0px_0px_1px_rgba(88,102,126,0.48))_drop-shadow(0px_0px_24px_rgba(88,102,126,0.10))] tw:lg:after:absolute tw:lg:after:right-[calc(50%-6px)] tw:lg:after:w-2.5 tw:lg:after:h-2.5 tw:lg:after:translate-x-0 tw:lg:after:-translate-y-2/4 tw:lg:after:rotate-45 tw:lg:after:bg-white tw:lg:after:overflow-hidden tw:lg:after:pointer-events-none tw:lg:after:top-0",
		contentWrapper:
			"tw:flex tw:flex-row tw:justify-center tw:items-center tw:gap-2",
		contentIcon: "tw:text-[#0756C0] tw:text-xl tw:lg:text-[32px]",
		content:
			"tw:leading-4 tw:font-medium tw:text-xs tw:text-left tw:text-[#212121] tw:lg:max-w-[110px] tw:lg:font-semibold",
	},
	visitLink: {
		wrapper:
			"tw:inline-flex tw:w-full tw:group tw:justify-center tw:py-3 tw:px-2 tw:bg-[#0756C0] tw:rounded-[12px] tw:transition tw:duration-300 tw:gap-1.5 tw:cursor-pointer tw:hover:bg-[#0d4d9b]",
		contentWrapper: twJoin(
			"tw:pt-0.5 tw:text-center tw:text-base tw:leading-6 tw:font-semibold tw:whitespace-nowrap tw:text-white tw:lg:pt-1.5 tw:lg:leading-4",
			isDeemphasizedCompany && "tw:lg:text-sm",
		),
		iconClass:
			"tw:hidden tw:text-2xl tw:text-white tw:transition-all tw:duration-300 tw:group-hover:translate-x-1 tw:lg:inline-flex",
	},
});
